/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:21:50
 * @ Modified by: David Helmick
 * @ Modified time: 2025-10-24 16:13:05
 * @ Description: Dialog component in withSession that informs users that they have reached a limit. Has option to upgrade to more expensive plans
 */

import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'

import {
  Button,
  Card,
  CardContent,
  Dialog,
  Grid,
  Box,
} from '@mui/material'

import { enqueueSnackbar } from 'notistack'
import { useMutation } from '@apollo/client/react'
import { CREATE_SESSION } from '@/housefolios-components/LaunchpadComponents/mutations'

//import BonusProperties from '@/housefolios-components/Properties/BonusProperties';

function UpsellComponent(props) {
  const [createBillingPortalSession] = useMutation(CREATE_SESSION)
  const { openLimit, closeLimit } = props

  // const [openEditPortfolio, setEditPortfolio] = useState(false);
  // const handleOpenEditPortfolio = () => {
  //   setEditPortfolio(true);
  // }
  // const handleCloseEditPortfolio = () => {
  //   setEditPortfolio(false);
  // }

  const changePlan = async () => {
    var session = await createBillingPortalSession()

    window.open(
      session.data.createBillingPortalSession.url,
      '_self',
      '',
    )
  }

  var today = new Date()
  var resetDate = !isEmpty(props.session.me.activeOrg.subscriptions)
    ? props.session.me.activeOrg.subscriptions[0].current_period_end
      ? new Date(
          props.session.me.activeOrg.subscriptions[0]
            .current_period_end * 1000,
        )
      : null
    : props.session.me.activeOrg.parentCorp &&
        !isEmpty(props.session.me.activeOrg.parentCorp.subscriptions)
      ? props.session.me.activeOrg.parentCorp.subscriptions[0]
          .current_period_end
        ? new Date(
            props.session.me.activeOrg.parentCorp.subscriptions[0]
              .current_period_end * 1000,
          )
        : null
      : !isEmpty(
            props?.session?.me?.activeOrg
              ?.memberProvidedSubscriptions,
          )
        ? props?.session?.me?.activeOrg
            ?.memberProvidedSubscriptions[0].current_period_end
          ? new Date(
              props?.session?.me?.activeOrg
                ?.memberProvidedSubscriptions[0].current_period_end *
                1000,
            )
          : null
        : null
  if (!resetDate) {
    var month = today.getMonth()
    resetDate = new Date()
    if (month === 11) {
      resetDate.setFullYear(resetDate.getFullYear() + 1, 0, 1)
    } else resetDate.setMonth(month + 1, 1)
  }
  if (
    (resetDate.getFullYear() > today.getFullYear() &&
      (today.getMonth() !== 11 || resetDate.getMonth() !== 0)) ||
    resetDate.getMonth() > today.getMonth() + 1 ||
    resetDate.getMonth() === today.getMonth() + 1 ||
    resetDate.getDate() > today.getDate()
  ) {
    if (resetDate.getDate() > today.getDate()) {
      resetDate.setFullYear(today.getFullYear(), today.getMonth())
      if (resetDate.getMonth() !== today.getMonth())
        resetDate.setDate(0)
    } else {
      resetDate.setFullYear(today.getFullYear(), today.getMonth() + 1)
      if (
        resetDate.getMonth() !== today.getMonth() + 1 &&
        resetDate.getMonth() !== 0
      )
        resetDate.setDate(0)
    }
  }
  const timeToReset = resetDate - today
  const daysToReset = Math.floor(timeToReset / 1000 / 60 / 60 / 24)

  const text = {
    property: {
      icon: ['far', 'house-chimney'],
      title: 'Property Limit Reached',
      text: `Your monthly limit will reset in ${daysToReset} days.`,
      bonusProperties: true,
    },
    team: {
      icon: ['fas', 'user-plus'],
      title: 'Team Member Limit Reached',
      text: 'You must upgrade to add more team members.',
    },
    portfolio: {
      icon: ['far', 'folder'],
      title: 'Portfolio Limit Reached',
      text: 'You must upgrade to create more portfolios.',
    },
    marketplace: {
      icon: ['fas', 'sign-hanging'],
      title: 'Marketplace Limit Reached',
      text: 'You must upgrade to create more marketplaces.',
    },
    paul: {
      image: '/images/PaulMcComasHeadShot.png',
      title: 'Upgrade Plan',
      // text: 'Paul is accepting JV deals exclusively from Growth and Pro users'
      text: 'Now accepting JV deals exclusively from Growth and Pro users',
    },
  }

  return (
    <>
      <Dialog
        open={Boolean(openLimit)}
        onClose={closeLimit}
        scroll="body"
      >
        <Card>
          <CardContent>
            <Box sx={{ textAlign: 'center', p: '3rem' }}>
              <Box sx={[{ borderRadius: '50%', m: 0 }, {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                mr: "0.25rem",
                position: "relative",
                fontSize: "1.2rem",
                transition: "all 0.2s ease-in-out",
                "&:last-child": { mr: 0, marginRight: 0 },
                "& .badge": { position: "absolute", right: 0, bottom: 0 },
                "& svg, & .svg-inline--fa": { display: "block" },
                marginRight: "0.25rem",
              }]}>
                <Box style={{ backgroundColor: '#b3d7ff', color: '#008aff', }} sx={[{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: 0,
                  height: "130px !important",
                  width: "130px !important",
                  lineHeight: "130px !important",
                  p: 0,
                  borderRadius: "50%",
                  m: 0,
                }, {
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: "0.25rem",
                  position: "relative",
                  fontSize: "1.2rem",
                  transition: "all 0.2s ease-in-out",
                  "&:last-child": { mr: 0, marginRight: 0 },
                  "& .badge": { position: "absolute", right: 0, bottom: 0 },
                  "& svg, & .svg-inline--fa": { display: "block" },
                  marginRight: "0.25rem",
                }]}>
                  {text[openLimit].icon && (
                    <FontAwesomeIcon icon={text[openLimit].icon} style={{ display: 'flex', alignSelf: 'center' }} sx={{ fontSize: "3rem", fontWeight: "300", lineHeight: "1.2" }} />
                  )}
                  {text[openLimit].image && (
                    <img
                      src={text[openLimit].image}
                      alt="paulmccomas"
                      width={100}
                    />
                  )}
                </Box>
              </Box>
              <Box
                component="h4"
                sx={{ fontWeight: 700, mt: '1.5rem' }}
              >
                {text[openLimit].title}
                {/* Team Member Limit Reached
                  Portfolio Limit Reached
                  Marketplace Limit Reached */}
              </Box>
              <Box component="p" sx={[{ mb: 0, color: '#a6a6b9' }, { fontSize: "1.15rem !important" }]}>
                {text[openLimit].text}
              </Box>
              <Box sx={{ pt: '1.5rem' }}>
                <Grid
                  container
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: 'center',
                  }}
                >
                  {/* {text[openLimit].bonusProperties && (
                    <Grid>
                      <BonusProperties session={props.session} upsell={true} />
                    </Grid>
                  )} */}
                  <Grid>
                    <Button
                      onClick={changePlan}
                      variant="contained"
                      color="primary"
                    >
                      See Plans
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Dialog>
    </>
  )
}

export default UpsellComponent
